import { render, staticRenderFns } from "./AsignacionForm.vue?vue&type=template&id=28f0aaaa&scoped=true"
import script from "./AsignacionForm.vue?vue&type=script&lang=js"
export * from "./AsignacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0aaaa",
  null
  
)

export default component.exports